module.exports = __webpack_public_path__ + "img/lightChallenge.780c36ce.webp";